var _path, _path2, _path3, _path4, _path5, _rect, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReportPdf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#475467",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.667,
    d: "M17 29h-5.6c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748C5 25.96 5 24.506 5 22.266V8.4c0-2.24 0-3.36.436-4.216a4 4 0 0 1 1.748-1.748C8.04 2 9.16 2 11.4 2H19l8 8v9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF3600",
    fillOpacity: 0.5,
    d: "m20.429 13.024-3.17-1.816a2.545 2.545 0 0 0-2.518 0l-3.17 1.816a2.49 2.49 0 0 0-1.259 2.16v3.631a2.489 2.489 0 0 0 1.26 2.16l3.17 1.816a2.54 2.54 0 0 0 2.517 0l3.17-1.815a2.489 2.489 0 0 0 1.259-2.16v-3.632a2.489 2.489 0 0 0-.34-1.247 2.509 2.509 0 0 0-.92-.913Zm-.137 4.447-1.733 2.98c-.2.342-.502.614-.864.778-.363.164-.645.198-1.019.253-.563.081-1.05.114-1.384.03a1.928 1.928 0 0 1-.884-.498l-2.456-2.433a1.88 1.88 0 0 1-.547-1.13 1.87 1.87 0 0 1 .255-.95l1.734-2.98c.171-.295.42-.538.719-.704.299-.166.777-.231 1.35-.299.383-.045.742-.106 1.085-.05.343.057.755.25 1.037.53l2.453 2.43c.237.235.408.527.496.848.055.414-.03.835-.242 1.195Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF3600",
    fillOpacity: 0.5,
    d: "m17.11 14.375-2.86 2.115 1.848 1.008-.77 2.127 2.86-2.115-1.849-1.008.77-2.127Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#475467",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m20.667 26.667 4 4m0 0 4-4m-4 4v-8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#475467",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.667,
    d: "M19 3v5.507c0 .747 0 1.48.145 1.765.128.25.332.455.583.583.285.145.525.145 1.272.145h5"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 9,
    x: 2,
    y: 16,
    fill: "#DF3030",
    rx: 1
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3.92 17.788h1.96c.56 0 .995.077 1.304.232.315.155.534.363.656.624.123.261.184.555.184.88 0 .341-.063.65-.191.928-.128.277-.347.499-.657.664-.309.16-.74.24-1.296.24H4.793V23.5H3.92v-5.712Zm1.952 2.832c.347 0 .611-.043.793-.128a.722.722 0 0 0 .383-.368c.075-.165.112-.357.112-.576 0-.235-.037-.427-.112-.576-.074-.15-.208-.261-.4-.336-.186-.075-.447-.112-.784-.112H4.793v2.096h1.08Zm3.103-2.832h2.048c.854 0 1.518.235 1.992.704.475.464.712 1.168.712 2.112 0 .955-.253 1.677-.76 2.168-.507.485-1.205.728-2.096.728H8.975v-5.712Zm1.928 4.952c.662 0 1.144-.187 1.448-.56.304-.373.456-.893.456-1.56 0-.661-.141-1.173-.424-1.536-.277-.363-.728-.544-1.352-.544H9.855v4.2h1.048Zm3.838-4.952h3.616v.76H15.62v1.736h2.568v.776H15.62v2.44h-.88v-5.712Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportPdf);
export default __webpack_public_path__ + "static/media/reportPdf.5b810a733c3e58a044b87a0914bed7c5.svg";
export { ForwardRef as ReactComponent };